import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Page } from '../../models/page-wrapper.model';
import { Permission } from './permission.model';

@Injectable({
  providedIn: 'root'
})

export class PermissionService {
  private apiUrl = `${environment.restApiUrl}permissions`;

  constructor(private http: HttpClient) { }

  // Get all permissions with pagination
  getAllPermissions(params?: any): Observable<Page<Permission>> {
    return this.http.get<Page<Permission>>(this.apiUrl, { params: params }).pipe(
      catchError(this.handleError)
    );
  }



  private handleError(error: any): Observable<never> {
    console.error('An error occurred in RolesService:', error);
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }
}